/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Dialog_CancelInputs */

const en_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_input_position_dialog_cancel = /** @type {(inputs: Input_Position_Dialog_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Input_Position_Dialog_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_dialog_cancel = /** @type {((inputs?: Input_Position_Dialog_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Dialog_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_dialog_cancel(inputs)
	if (locale === "de") return de_input_position_dialog_cancel(inputs)
	if (locale === "it") return it_input_position_dialog_cancel(inputs)
	if (locale === "ru") return ru_input_position_dialog_cancel(inputs)
	if (locale === "es") return es_input_position_dialog_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_dialog_cancel(inputs)
	if (locale === "ja") return ja_input_position_dialog_cancel(inputs)
	if (locale === "hi") return hi_input_position_dialog_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_dialog_cancel(inputs)
	return en_input_position_dialog_cancel(inputs)
});